import React, { Component } from 'react'
import { Button, Form, Table, Input, Row, Col, Tag, DatePicker, Drawer, Icon } from 'antd'
import moment from 'moment'

import { getReturnForm, getReturnDetailStatus } from '_src/api/api'
import ReturnDetail from './returnDetail'

import { statusName } from './commo/common'

import '_src/common/style/common.less' 


const { RangePicker } = DatePicker
const { Search } = Input

@Form.create({ name: '' })
class ReturnForm extends Component {
  constructor (props) {
    super(props)
    // 参数集合
    this.param = {
      serviceNum: '', // 服务单号
      contacts: '', // 收货人
      pageNum: 0,
      createStart: '',
      createEnd: '',
      totalElements: 0
    }
    this.state = {
      id: '',
      itemStatus: '',
      status: '',
      loading: true,
      visible: false,
      dataList: [],
      statusBtns: []
    }
  }

  componentDidMount () {
    this.loadData()
    getReturnDetailStatus()
      .then(res=>{
        const { data } = res
        const arr = data.map(item=>{
          item.status = item.status === '总数'? '' : item.status
          return {text: statusName(item.status).text, num: item.count, id: item.status}
        })
        this.setState({
          statusBtns: arr
        })
      })
  }
  loadData () {
    this.setState({loading: true})
    const { pageNum, serviceNum, contacts, createAt, createStart, createEnd } = this.param
    const { status } = this.state
    let param = {pageNum, status, pageSize: 10}
    if (!!serviceNum) {
      param = {...param, serviceNum}
    }
    if (!!contacts) {
      param = {...param, contacts}
    }
    if (!!createAt) {
      param = {...param, createAt}
    }
    if (!!createStart&&!!createEnd) {
      param = {...param, createStart, createEnd}
    }
    // 获取列表信息
    getReturnForm(param)
      .then(res=>{
        const { data } = res
        this.param.totalElements = data.totalElements
        const dataList = data.content.map(item=>{
          const { serviceNum, createAt, contacts, status, order: { realPrice }, user: { mobile}, returnProcess } = item
          let processTime = ''
          !!(returnProcess instanceof Array) && returnProcess.forEach(item=>{
            if (item.status === 1) {
              processTime = item.createAt
            }
          }
          ) 
          return {serviceNum, createAt, contacts, status, realPrice, mobile, processTime, key: item.id, id: item.id}
        })
        this.setState({
          dataList: dataList,
          loading: false,
          visible: false
        })
      })
  }
  
  columns = () => {
    return [
      {
        title: <span>服务单号</span>,
        align: 'center',
        dataIndex: 'serviceNum',
        key: 'serviceNum',
      },
      {
        title: <span>申请时间</span>,
        align: 'center',
        dataIndex: 'createAt',
      },
      {
        title: <span>用户账号</span>,
        align: 'center',
        dataIndex: 'mobile',
      },     
      {
        title: <span>退款金额(元)</span>,
        align: 'center',
        dataIndex: 'realPrice',
        render: item => (item / 100).toFixed(2)
      },
      {
        title: <span>联系人</span>,
        align: 'center',
        dataIndex: 'contacts',
      },
      {
        title: <span>申请状态</span>,
        align: 'center',
        dataIndex: 'status',
        render: status => (
          <Tag color={statusName(status).color}>{statusName(status).text}</Tag>
        )
    
      },
      {
        title: <span>处理时间</span>,
        align: 'center',
        dataIndex: 'processTime',
        
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div>
          <Button icon="eye" style={{marginRight: '10px'}} onClick = { () => { this.openDrawer(record) } } >详情</Button>
        </div>,
      },
    ]
  }

  // 关闭抽屉
  onClose = () => {
    this.setState({
      visible: false
    })
  }

  // 打开抽屉
  openDrawer = (record) => {
    this.setState(()=>({
      visible: true,
      id: record.id,
      itemStatus: record.status
    }))
  }
  // 搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }
  // 时间搜索
  handleDateSearch = (key, _, dateString) => {
    this.param[key] = dateString
    this.param.pageNum = 0
    this.loadData()
  }
  timerChange = (e) => {
    this.param.pageNum = 0
    
    this.param.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
    this.param.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    
  
    this.loadData()
  }
  // 状态按钮搜索
  handleBtnSearch = (status) => {
    this.setState({
      status
    }, ()=>{
      this.param.pageNum = 0
     
      this.loadData()
    })
  }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, loading, status, visible, id, itemStatus, statusBtns } = this.state
    const { pageNum, totalElements } = this.param
    // const statusBtns = [
    //   {text: '全部申请', num: this.totalElements},
    //   {text: '待处理', num: this.totalElements},
    //   {text: '退货中', num: this.totalElements},
    //   {text: '已完成', num: this.totalElements},
    //   {text: '已拒绝', num: this.totalElements},
    // ]

    const drawerHeader = (
      <div className = "page_top">
        <p className = "page_top_title">
          服务详情-<span style = {{color: statusName(itemStatus).color}}>{statusName(itemStatus).text}</span>
        </p>
        <div className = "returnDetail_btn">
          <Button className = "" type="primary" onClick = {this.onClose}>
            <Icon type="left" />
            返回
          </Button>
        </div>
      </div>
    )
    return (
      <div className = "ReturnForm page_content" >
        <div className = "top" >
          {
            statusBtns.map((item, index)=>(
              <SearchButton key = {index} id = {item.id} state = {status} handleSearch = {this.handleBtnSearch} label = {item} />
            ))
          }
          
        </div>
        
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "服务单号" >
                  <Search placeholder="请输入服务单号" onSearch={(v)=>{ this.handleSearch('serviceNum', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "收货人">
                  <Search placeholder="请输入收货人" onSearch={(v)=>{ this.handleSearch('contacts', v) }}enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "申请时间">
                  

                  <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
     
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {loading} 
          bordered
  
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Drawer
          title={drawerHeader}
          width={'900'}
          onClose={this.onClose}
          destroyOnClose
          closable = {false}
          visible = {visible}
        >
          <ReturnDetail id = {id} />
        </Drawer>
        
      </div>
    )
  }
}


const SearchButton = (props) => {
  function handleClick (id) {
    const { handleSearch } = props   
    // const { handleSearch } = this.props
    handleSearch && handleSearch(id)
  }
  const { label, state, id} = props
  const { text, num } = label|| {}
  return (
    <Button className = {`filterBtn ${state === id?'act':''}`} onClick = {()=>{ handleClick(id) }}>
      {text}<span className = "num">{num&&`（${num}）`}</span>
    </Button>
  )
}

export default ReturnForm